import { createSelector } from 'reselect';
import { AuthStatus } from '../models';
import status from './status';

export default createSelector(status, (auth) => auth === AuthStatus.Unknown);
